import { styled } from '@mui/material/styles';
import { Box, Container, Grid, IconButton, Stack, Tooltip, Typography } from '@mui/material';
import { useIntl } from 'react-intl';
import Image from 'next/image';
import Link from 'next/link';
import { IconBrandFacebook, IconBrandInstagram, IconBrandLinkedin, IconBrandYoutube } from '@tabler/icons-react';

const logo = '/assets/images/logo-dark.svg';

const FooterLink = styled(Link)(({ theme }) => ({
  color: 'white',
  '&:hover': {
    color: '#EE741E'
  },
  '&:active': {
    color: '#EE741E'
  },
  target: '_self',
  fontSize: 14
}));

const FooterSection = () => {
  const { formatMessage } = useIntl();

  const services = [
    {
      title: formatMessage({ id: 'SOFTWARE.DEVELOPMENT' }),
      link: 'services'
      // link: '/software-development'
    },
    {
      title: formatMessage({ id: 'OUTSOURCE.SERVICES' }),
      link: 'services'
      // link: '/outsource-services'
    },
    {
      title: formatMessage({ id: 'CASH.MANAGEMENT.PRODUCTS' }),
      link: 'services'
      // link: '/cash-management-products'
    },
    {
      title: formatMessage({ id: 'HARDWARE.PRODUCTS' }),
      link: 'services'
      // link: '/hardware-products'
    },
    {
      title: formatMessage({ id: 'INTEGRATION' }),
      link: 'services'
      // link: '/integration'
    },
    {
      title: formatMessage({ id: 'PEN.TEST' }),
      link: 'services'
      // link: '/pen-test'
    },
    {
      title: formatMessage({ id: 'SUPPORT.SERVICE' }),
      link: 'services'
      // link: '/support-service'
    }
  ];

  const categories = [
    {
      title: formatMessage({ id: 'ABOUT' }),
      link: '/about'
    },
    {
      title: formatMessage({ id: 'OUR.PRODUCTS' }),
      link: '/products'
    },
    {
      title: formatMessage({ id: 'SERVICES' }),
      link: '/services'
    },
    // {
    //   title: formatMessage({ id: 'BLOG' }),
    //   link: '/blog'
    // },
    {
      title: formatMessage({ id: 'SUPPORT' }),
      link: '/support'
    },
    {
      title: formatMessage({ id: 'CAREER' }),
      link: '/career'
    },
    {
      title: formatMessage({ id: 'CONTACT' }),
      link: '/contact'
    }
  ];

  const policies = [
    {
      title: formatMessage({ id: 'COOKIE.POLICY' }),
      link: '/cookie-policy'
    },
    {
      title: formatMessage({ id: 'KVKK.POLICY' }),
      link: '/kvkk'
    },
    {
      title: formatMessage({ id: 'PRIVACY.POLICY' }),
      link: '/privacy-policy'
    },
    {
      title: formatMessage({ id: 'QUALITY.POLICY' }),
      link: '/quality-policy'
    },
    {
      title: formatMessage({ id: 'OUT.CERTIFICATES' }),
      link: '/our-certificates'
    }
  ];

  return (
    <>
      <Container sx={{ mb: { xs: 4, lg: 8 } }}>
        <Grid container spacing={{ xs: 1.5, sm: 2.5, md: 3, lg: 5 }}>
          <Grid size={{ xs: 12 }}>
            <Grid container spacing={{ xs: 5, md: 2 }} display="flex" justifyContent="center" alignItems="flex-start">
              <Grid size={{ xs: 6, sm: 3 }}>
                <Stack spacing={{ xs: 3, md: 4 }}>
                  <Typography variant="h4" color="white" fontWeight={500} fontSize={18}>
                    {formatMessage({ id: 'OUR.SERVICES' })}
                  </Typography>
                  <Stack spacing={{ xs: 1.5, md: 2 }}>
                    {services.map((item, index) => (
                      <FooterLink href={item.link} key={index}>
                        {item.title}
                      </FooterLink>
                    ))}
                  </Stack>
                </Stack>
              </Grid>
              <Grid size={{ xs: 6, sm: 3 }} display="flex" justifyContent="center" alignItems="flex-start">
                <Stack spacing={{ xs: 3, md: 4 }}>
                  <Typography variant="h4" color="white" fontWeight={500} fontSize={18}>
                    {formatMessage({ id: 'FOOTER.CATEGORIES' })}
                  </Typography>
                  <Stack spacing={{ xs: 1.5, md: 2 }}>
                    {categories.map((item, index) => (
                      <FooterLink href={item.link} key={index}>
                        {item.title}
                      </FooterLink>
                    ))}
                  </Stack>
                </Stack>
              </Grid>
              <Grid size={{ xs: 6, sm: 3 }} display="flex" justifyContent="center" alignItems="flex-start">
                <Stack spacing={{ xs: 3, md: 4 }}>
                  <Typography variant="h4" color="white" fontWeight={500} fontSize={18}>
                    {formatMessage({ id: 'FOOTER.CERTIFICATES.AND.POLICIES' })}
                  </Typography>
                  <Stack spacing={{ xs: 1.5, md: 2 }}>
                    {policies.map((item, index) => (
                      <FooterLink href={item.link} key={index}>
                        {item.title}
                      </FooterLink>
                    ))}
                  </Stack>
                </Stack>
              </Grid>

              <Grid size={{ xs: 6, sm: 3 }} display="flex" justifyContent="center" alignItems="flex-start">
                <Stack spacing={{ xs: 3, md: 3 }}>
                  <Typography variant="h4" color="white" fontWeight={500} fontSize={18}>
                    {formatMessage({ id: 'CONTACT' })}
                  </Typography>
                  <Stack spacing={{ xs: 1.5, md: 1 }}>
                    <Typography variant="h4" color="white" fontWeight={400}>
                      <FooterLink href="tel:+90 212 295 2230">+90 (212) 295 2230</FooterLink>
                    </Typography>
                    <Typography variant="h4" color="white" fontWeight={400}>
                      <FooterLink href="mailto:destek@andevos.com.tr">destek@andevos.com.tr</FooterLink>
                    </Typography>
                  </Stack>
                  <Typography variant="h4" color="white" fontWeight={500} fontSize={18}>
                    {formatMessage({ id: 'CONTACT.US' })}
                  </Typography>
                  <Stack direction="row" alignItems="start" justifyContent="start" spacing={{ xs: 3, sm: 1.5, md: 2 }}>
                    <Stack direction="column" alignItems="start" justifyContent="start" spacing={{ xs: 3, sm: 1.5, md: 2 }}>
                      <Tooltip title="LinkedIn">
                        <Link href="https://www.linkedin.com/company/andevos/" target="_blank">
                          <IconButton
                            size="large"
                            disableRipple
                            aria-label="LinkedIn"
                            sx={{
                              color: 'white',
                              padding: 0,
                              margin: '4px 0',
                              '&:hover': {
                                color: '#0077B5'
                              }
                            }}
                          >
                            <IconBrandLinkedin />
                          </IconButton>
                        </Link>
                      </Tooltip>
                      <Tooltip title="Instagram">
                        <Link href="https://www.instagram.com/andevosbilgiteknolojileri/" target="_blank">
                          <IconButton
                            size="large"
                            disableRipple
                            aria-label="Instagram"
                            sx={{
                              color: 'white',
                              padding: 0,
                              margin: '4px 0',
                              '&:hover': {
                                color: '#E4405F'
                              }
                            }}
                          >
                            <IconBrandInstagram />
                          </IconButton>
                        </Link>
                      </Tooltip>
                    </Stack>
                    <Stack direction="column" alignItems="start" justifyContent="start" spacing={{ xs: 3, sm: 1.5, md: 2 }}>
                      <Tooltip title="Facebook">
                        <Link href="https://www.facebook.com/andevosbt" target="_blank">
                          <IconButton
                            size="large"
                            disableRipple
                            aria-label="Facebook"
                            sx={{
                              color: 'white',
                              padding: 0,
                              margin: '4px 0',
                              '&:hover': {
                                color: '#1877F2'
                              }
                            }}
                          >
                            <IconBrandFacebook />
                          </IconButton>
                        </Link>
                      </Tooltip>
                      <Tooltip title="Youtube">
                        <Link href="https://www.youtube.com/@AndevosBilgiTeknolojileri" target="_blank">
                          <IconButton
                            size="large"
                            disableRipple
                            aria-label="Youtube"
                            sx={{
                              color: 'white',
                              padding: 0,
                              margin: '4px 0',
                              '&:hover': {
                                color: '#FF0000'
                              }
                            }}
                          >
                            <IconBrandYoutube />
                          </IconButton>
                        </Link>
                      </Tooltip>
                    </Stack>
                  </Stack>
                </Stack>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
      <Box sx={{ bgcolor: 'dark.dark', py: { xs: 3, sm: 1.5 } }}>
        <Container>
          <Stack
            direction="row"
            alignItems={{ xs: 'center', sm: 'center' }}
            justifyContent="space-between"
            spacing={{ xs: 1.5, sm: 1, md: 3 }}
          >
            <Image src={logo} alt="Andevos" width="140" height="37" />

            <Typography color="white" textAlign="end">
              © 2025 — Copyright by <br />
              <Link href="https://andevos.com.tr/" target="_blank">
                Andevos Bilgi Teknolojiler ve Pazarlama A.Ş.
              </Link>
            </Typography>
          </Stack>
        </Container>
      </Box>
    </>
  );
};

export default FooterSection;
